module.exports = __webpack_public_path__ + "img/feature-shop.65184637.jpg";